import { cn } from '../../../../utils/cn';
import { useTable } from '../TableContext';

type TableRowSpacerProps = React.HTMLAttributes<HTMLTableRowElement>;

export function TableRowSpacer({ className, ...props }: TableRowSpacerProps) {
  const { variant } = useTable();

  return (
    <tr
      className={cn(
        variant === 'rounded'
          ? 'h-4 bg-transparent'
          : 'h-[10px] bg-gray-50/30 dark:bg-gray-800/30',
        className,
      )}
      aria-hidden
      {...props}
    >
      <td className="p-0" colSpan={999}></td>
    </tr>
  );
}

TableRowSpacer.displayName = 'TableRowSpacer';
